import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { Page, Loadable, DataTable, Fab } from "components/support";

import { colors, Icon } from "assets";
import Filter from "./filter";
import SummaryCard from "./summary-card";
import { fn } from "util";
import _ from "lodash";

class DevolutionSellableReportView extends Component {
  devolutionConfig = {
    identifier: "sale_id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        id: "created_at",
        accessor: "created_at",
        type: "datetime",
        align: "center",
        Header: "Data"
      },
      {
        id: "total_value",
        accessor: ({ total_value }) => fn.centsToReal(total_value),
        Header: "Valor Total",
        type: "money",
        align: "right"
      },
      {
        accessor: "sellable.code",
        align: "center",
        Header: "Código do Produto"
      },
      {
        accessor: "sellable.name",
        align: "left",
        Header: "Nome Produto"
      },
      {
        accessor: "quantity",
        align: "right",
        Header: "Quantidade"
      },
      {
        accessor: "credit_coupon.code",
        align: "center",
        Header: "Devolução"
      },
      {
        accessor: "salesman.name",
        align: "left",
        Header: "Vendedor"
      }
    ]
  };

  productConfig = {
    identifier: "product_id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        id: "sellable_code",
        accessor: report => _.get(report, "sellable_code") || "-",
        align: "center",
        Header: "Código"
      },
      {
        id: "sellable_name",
        accessor: report => _.get(report, "sellable_name") || "-",
        Header: "Nome",
        align: "left"
      },
      {
        id: "sellable_quantity",
        accessor: report => _.get(report, "sellable_quantity") || "-",
        align: "center",
        Header: "Quantidade Devolvida"
      },
      {
        id: "sellable_total_value",
        type: "money",
        accessor: report => report.sellable_total_value,
        align: "right",
        Header: "Total Devolvido"
      }
    ]
  };

  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      results,
      pagination,
      order,
      summary,
      userSearchOptions,
      productSearchOptions,
      product,
      user,
      mode
    } = viewModel;

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Relatório de Devoluções por Produto
        </Typography>

        <Row>
          <Col xs={12} md={8}>
            <Filter
              loading={loading}
              filters={filters}
              product={product}
              user={user}
              productSearchOptions={productSearchOptions}
              userSearchOptions={userSearchOptions}
              onSelectProduct={product => presenter.onSelectProduct(product)}
              onChange={filters => presenter.onFilterChange(filters)}
              onFilter={filters => this.props.presenter.onFilterChange(filters)}
            />
          </Col>
          <Col xs={12} md={4}>
            <SummaryCard
              loading={loading}
              value={summary.total}
              label="Total"
            />
          </Col>
        </Row>

        <Loadable loading={loading}>
          <Paper elevation={1}>
            <DataTable
              manual
              defaultSorted={[
                {
                  id: mode === "product" ? "sellable_code" : "created_at",
                  desc: mode === "product" ? true : false
                }
              ]}
              defaultSort
              filterable={false}
              resultSet={results}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.page}
              config={
                mode === "product" ? this.productConfig : this.devolutionConfig
              }
              onChange={({ field, value }) =>
                presenter.onOrderChange(field, value)
              }
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={page => presenter.onPageChange(page + 1)}
            />
          </Paper>
        </Loadable>

        {this.downloadButton()}
      </Page>
    );
  }
}

export default DevolutionSellableReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/devolution-sellable-report/view.jsx